export const COOKIES_KEYS = {
  token: '@app:token',
  account: '@app:account',
}
